<template>
  <el-dialog
    class="common-dialog build-dialog"
    :title="dialogOptions.title"
    :visible.sync="visible"
    center
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    @close="dialogClose"
    :append-to-body="appendToBody"
  >
    <div class="dialog-input-container">
      <label>{{ dialogOptions.label }}</label>
      <el-input v-model="inputMsn"></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" @click="clickCancel" size="small">{{ '取 消' }}</el-button>
      <el-button type="primary" @click="clickConfirm" size="small">{{ '完 成' }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'addTipDialog',
  props: {
    dialogOptions: {
      type: Object,
      default: function() {
        return {
          type: 'build',
          title: '提示',
          label: '',
          value: '',
          message: '必须填写'
        }
      }
    },
    appendToBody: { type: Boolean, default: false }
  },
  data() {
    return {
      visible: false,
      inputMsn: this.dialogOptions.value
    }
  },
  methods: {
    dialogClose() {
      this.inputMsn = this.dialogOptions.value
      this.$emit('clickCancel')
    },
    clickCancel() {
      this.visible = false
      this.inputMsn = this.dialogOptions.value
      this.$emit('clickCancel')
    },
    clickConfirm() {
      if (this.inputMsn == '') {
        this.$message({
          message: this.dialogOptions.message,
          type: 'error'
        })
        return false
      }
      if (this.inputMsn.length > 20) {
        return false
      }

      this.visible = false
      this.$emit('clickConfirm', this.inputMsn)
      this.inputMsn = this.dialogOptions.value
    }
  },
  watch: {
    inputMsn: function(val) {
      if (val.length > 20) {
        this.$message({
          message: '最多可以输入20个字符',
          type: 'warning'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.build-dialog {
  .dialog-input-container {
    display: flex;
    label {
      width: 105px;
      height: 35px;
      line-height: 35px;
    }
    /deep/ .el-input {
      height: 35px !important;
      .el-input__inner {
        height: 35px !important;
        line-height: 35px !important;
      }
    }
  }
}
</style>
